// extracted by mini-css-extract-plugin
export default {"container":"table-footer_container__1D1h9"};